import { render } from "./App.vue?vue&type=template&id=186509c6&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=186509c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-186509c6"

export default script